
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.312 16.662l8.21-13.918a.556.556 0 01.957 0l8.209 13.918a.556.556 0 01-.479.838H1.791a.556.556 0 01-.479-.838z","fill":"#ae3f13"}}),_c('path',{staticClass:"gst-svg-icon",attrs:{"d":"M10 15.831a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z","fill":"#181e25"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 12.31c.544 0 .984-.44.984-.983V8.105a.984.984 0 00-1.967 0v3.222c0 .543.44.984.983.984z","fill":"#181e25"}})])
          )
        }
      }
    